export default __webpack_public_path__ + "static/media/wave.fe375ffe.wav";